// exp_PORTFOLIO-61587_file
import { FC, useMemo } from 'react';

import vacancyOfTheDayFormFieldTouch from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/vacancy_of_the_day/vacancy_of_the_day_form_field_touch';

import useTrls from 'hooks/translation/useTrls';

import { MultiSelectField } from 'components/VacancyOfTheDayBuilder/components/MultiSelectField';
import {
    formatVacancyOfTheDayIds,
    getVacancyOfTheDayIdSource,
    useVacancyOfTheDayAnalyticsParams,
} from 'components/VacancyOfTheDayBuilder/useVacancyOfTheDayAnalyticsParams';

import { Region, selectRegions } from 'store/autoReducers';
import {
    selectVacancyOfTheDayAreas,
    selectVacancyOfTheDayErrors,
    setVacancyOfTheDayAreas,
    setVacancyOfTheDayErrors,
} from 'store/models/vacancyOfTheDay';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'VacancyOfTheDayPage.areas.title',
    placeholder: 'VacancyOfTheDayPage.areas.placeholder',
    error: 'VacancyOfTheDayPage.areas.error',
    select: 'VacancyOfTheDayPage.select.button',
    apply: 'VacancyOfTheDayPage.select.apply',
    reset: 'VacancyOfTheDayPage.select.reset',
    searchPlaceholder: 'VacancyOfTheDayPage.select.searchPlaceholder',
    emptyTitle: 'VacancyOfTheDayPage.select.empty.title',
    emptyDescription: 'VacancyOfTheDayPage.select.empty.description',
};

interface AreaOption {
    value: string;
    text: string;
}

const flattenRegions = (regions: Region[]): AreaOption[] =>
    regions.flatMap((region) => [
        { value: region.id, text: region.name },
        ...(region.areas ? flattenRegions(region.areas) : []),
    ]);

export const Areas: FC = () => {
    const areas = useSelector(selectVacancyOfTheDayAreas);
    const invalid = useSelector(selectVacancyOfTheDayErrors).areas;
    const regions = useSelector(selectRegions);

    const options = useMemo(() => flattenRegions(regions), [regions]);

    const dispatch = useDispatch();
    const trls = useTrls();
    const { params, initialAreas } = useVacancyOfTheDayAnalyticsParams();

    return (
        <MultiSelectField
            title={trls(TrlKeys.title)}
            placeholder={trls(TrlKeys.placeholder)}
            errorMessage={trls(TrlKeys.error)}
            invalid={invalid}
            options={options}
            selected={areas}
            onChange={(ids) => {
                dispatch(setVacancyOfTheDayAreas(ids));
                if (ids.length > 0) {
                    dispatch(setVacancyOfTheDayErrors({ areas: false }));
                }
                vacancyOfTheDayFormFieldTouch({
                    ...params,
                    fieldName: 'geo',
                    geoIds: formatVacancyOfTheDayIds(ids),
                    geoSource: getVacancyOfTheDayIdSource(ids, initialAreas),
                    roleIds: null,
                    roleSource: 'None',
                });
            }}
            onBlur={() => dispatch(setVacancyOfTheDayErrors({ areas: areas.length === 0 }))}
            dataQa="vacancy-of-the-day-areas"
            selectLabel={trls(TrlKeys.select)}
            applyLabel={trls(TrlKeys.apply)}
            resetLabel={trls(TrlKeys.reset)}
            searchPlaceholder={trls(TrlKeys.searchPlaceholder)}
            emptyTitle={trls(TrlKeys.emptyTitle)}
            emptyDescription={trls(TrlKeys.emptyDescription)}
        />
    );
};
